<template>
  <!-- Add Cron Schedule -->
  <div class="modal fade" id="add_cronjobschedule">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Add Schedule</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="handleCreate">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="createForm.name"
                    placeholder="e.g. Every 5 minutes"
                    required
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Interval</label>

                  <!-- ✅ Simple preset dropdown (Bootstrap select) -->
                  <select
                    v-if="!advancedMode"
                    class="form-select"
                    v-model="createForm.interval"
                    required
                  >
                    <optgroup label="Simple">
                      <option disabled value="">Select interval</option>
                      <option value="every_minute">Every minute</option>
                      <option value="every_5_minutes">Every 5 minutes</option>
                      <option value="every_10_minutes">Every 10 minutes</option>
                      <option value="every_15_minutes">Every 15 minutes</option>
                      <option value="every_30_minutes">Every 30 minutes</option>
                      <option value="hourly">Hourly</option>
                      <option value="every_2_hours">Every 2 hours</option>
                      <option value="every_6_hours">Every 6 hours</option>
                      <option value="daily">Daily (same time)</option>
                      <option value="weekly">
                        Weekly (same weekday &amp; time)
                      </option>
                      <option value="monthly">
                        Monthly (same day &amp; time)
                      </option>
                    </optgroup>

                    <optgroup label="Daily at fixed time">
                      <option value="daily_at_09:00">Daily at 09:00</option>
                      <option value="daily_at_21:00">Daily at 21:00</option>
                    </optgroup>

                    <optgroup label="Weekly on day &amp; time">
                      <option value="weekly_mon_09:00">Monday at 09:00</option>
                      <option value="weekly_fri_17:30">Friday at 17:30</option>
                      <option value="weekly_sun_08:00">Sunday at 08:00</option>
                    </optgroup>

                    <optgroup label="Monthly (specific day)">
                      <option value="monthly_1st_09:00">1st at 09:00</option>
                      <option value="monthly_15th_09:00">15th at 09:00</option>
                    </optgroup>

                    <optgroup label="Monthly (last day)">
                      <option value="monthly_last_09:00">
                        Last day at 09:00
                      </option>
                    </optgroup>
                  </select>

                  <!-- ✳ Advanced custom pattern -->
                  <input
                    v-else
                    type="text"
                    class="form-control"
                    v-model="createForm.interval"
                    placeholder="e.g. weekly_mon_09:00"
                  />

                  <small class="text-muted d-block mt-1">
                    Pattern examples:
                    <code>every_5_minutes</code>, <code>daily</code>,
                    <code>daily_at_09:00</code>, <code>weekly_mon_09:00</code>,
                    <code>monthly_1st_09:00</code>,
                    <code>monthly_last_09:00</code>.
                  </small>

                  <button
                    type="button"
                    class="btn btn-link btn-sm px-0 mt-1"
                    @click="advancedMode = !advancedMode"
                  >
                    {{
                      advancedMode
                        ? "Use preset intervals"
                        : "Advanced: type custom pattern"
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              :disabled="saving"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span
                v-if="saving"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Add Schedule
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add Cron Schedule -->

  <!-- Edit Cron Schedule -->
  <div class="modal fade" id="edit_cronjobschedule">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Edit Schedule</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="handleUpdate">
          <div class="modal-body pb-0" v-if="editForm.id">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editForm.name"
                    required
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
               <label class="form-label">Interval</label>

<!-- ✅ Simple preset dropdown (Bootstrap select) -->
<select
  v-if="!advancedMode"
  class="form-select"
  v-model="createForm.interval"
  required
>
  <optgroup label="Simple">
    <option disabled value="">Select interval</option>
    <option value="every_minute">Every minute</option>
    <option value="every_5_minutes">Every 5 minutes</option>
    <option value="every_10_minutes">Every 10 minutes</option>
    <option value="every_15_minutes">Every 15 minutes</option>
    <option value="every_30_minutes">Every 30 minutes</option>
    <option value="hourly">Hourly</option>
    <option value="every_2_hours">Every 2 hours</option>
    <option value="every_6_hours">Every 6 hours</option>
    <option value="daily">Daily (same time)</option>
    <option value="weekly">Weekly (same weekday &amp; time)</option>
    <option value="monthly">Monthly (same day &amp; time)</option>
  </optgroup>

  <optgroup label="Daily at fixed time">
    <option value="daily_at_09:00">Daily at 09:00</option>
    <option value="daily_at_21:00">Daily at 21:00</option>
  </optgroup>

  <optgroup label="Weekly on day &amp; time">
    <option value="weekly_mon_09:00">Monday at 09:00</option>
    <option value="weekly_fri_17:30">Friday at 17:30</option>
    <option value="weekly_sun_08:00">Sunday at 08:00</option>
  </optgroup>

  <optgroup label="Monthly (specific day)">
    <option value="monthly_1st_09:00">1st at 09:00</option>
    <option value="monthly_15th_09:00">15th at 09:00</option>
  </optgroup>

  <optgroup label="Monthly (last day)">
    <option value="monthly_last_09:00">Last day at 09:00</option>
  </optgroup>
</select>

<!-- ✳ Advanced custom pattern -->
<input
  v-else
  type="text"
  class="form-control"
  v-model="editForm.interval"
  placeholder="e.g. weekly_mon_09:00"
/>

<small class="text-muted d-block mt-1">
  Pattern examples:
  <code>every_5_minutes</code>, <code>daily</code>,
  <code>daily_at_09:00</code>, <code>weekly_mon_09:00</code>,
  <code>monthly_1st_09:00</code>, <code>monthly_last_09:00</code>.
</small>

<button
  type="button"
  class="btn btn-link btn-sm px-0 mt-1"
  @click="advancedMode = !advancedMode"
>
  {{
    advancedMode
      ? "Use preset intervals"
      : "Advanced: type custom pattern"
  }}
</button>

                
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body pb-0" v-else>
            <p class="mb-0">Select a schedule to edit.</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              :disabled="saving"
            >
              Cancel
            </button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              <span
                v-if="saving"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Save Schedule
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Edit Cron Schedule -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete all the marked items, this can't be undone once
            you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
            >
              Cancel
            </a>
            <button
              type="button"
              class="btn btn-danger"
              @click="handleConfirmDelete"
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>

<script setup>
import { ref, watch } from "vue";
import { Modal } from "bootstrap";
import { useCronScheduleStore } from "@/stores/settings/cron-schedule.store";
import { toast } from "@/utils/toast";

const emit = defineEmits(["confirm-delete"]);

const cronScheduleStore = useCronScheduleStore();

const saving = ref(false);

const intervalOptions = [
  // SIMPLE
  { label: "Every minute", value: "every_minute", group: "Simple" },
  { label: "Every 5 minutes", value: "every_5_minutes", group: "Simple" },
  { label: "Every 10 minutes", value: "every_10_minutes", group: "Simple" },
  { label: "Every 15 minutes", value: "every_15_minutes", group: "Simple" },
  { label: "Every 30 minutes", value: "every_30_minutes", group: "Simple" },
  { label: "Hourly (every hour)", value: "hourly", group: "Simple" },
  { label: "Every 2 hours", value: "every_2_hours", group: "Simple" },
  { label: "Every 6 hours", value: "every_6_hours", group: "Simple" },
  { label: "Daily (same time)", value: "daily", group: "Simple" },
  { label: "Weekly (same weekday & time)", value: "weekly", group: "Simple" },
  { label: "Monthly (same day & time)", value: "monthly", group: "Simple" },

  // DAILY AT FIXED TIME
  { label: "Daily at 09:00", value: "daily_at_09:00", group: "Daily at time" },
  { label: "Daily at 21:00", value: "daily_at_21:00", group: "Daily at time" },

  // WEEKLY WITH DAY+TIME
  {
    label: "Weekly – Monday 09:00",
    value: "weekly_mon_09:00",
    group: "Weekly by day",
  },
  {
    label: "Weekly – Friday 17:30",
    value: "weekly_fri_17:30",
    group: "Weekly by day",
  },
  {
    label: "Weekly – Sunday 08:00",
    value: "weekly_sun_08:00",
    group: "Weekly by day",
  },

  // MONTHLY SPECIFIC DAY
  {
    label: "Monthly – 1st at 09:00",
    value: "monthly_1st_09:00",
    group: "Monthly specific day",
  },
  {
    label: "Monthly – 15th at 09:00",
    value: "monthly_15th_09:00",
    group: "Monthly specific day",
  },

  // MONTHLY LAST DAY
  {
    label: "Monthly – last day at 09:00",
    value: "monthly_last_09:00",
    group: "Monthly last",
  },
];

const advancedMode = ref(false);

const createForm = ref({
  name: "",
  interval: "",
});

const editForm = ref({
  id: null,
  name: "",
  interval: "",
});

// Watch the "current" item from the store to populate the edit form
watch(
  () => cronScheduleStore.current,
  (val) => {
    if (val && val.id) {
      editForm.value.id = val.id;
      editForm.value.name = val.name || "";
      editForm.value.interval = val.interval || "";
    } else {
      editForm.value.id = null;
      editForm.value.name = "";
      editForm.value.interval = "";
    }
  },
  { immediate: true }
);

function resetCreateForm() {
  createForm.value.name = "";
  createForm.value.interval = "";
}

function closeModal(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const modal = Modal.getInstance(el) || new Modal(el);
  modal.hide();

  // Wait slightly for Bootstrap animations, then cleanup backdrops
  setTimeout(() => {
    forceModalCleanup();
  }, 200);
}

async function handleCreate() {
  if (!createForm.value.name || !createForm.value.interval) {
    toast("Please fill in both name and interval", "error");
    return;
  }

  saving.value = true;
  try {
    await cronScheduleStore.create({
      name: createForm.value.name,
      interval: createForm.value.interval,
      is_enabled: true,
    });
    resetCreateForm();
    closeModal("add_cronjobschedule");
  } catch (e) {
    // error toast already handled in the store
  } finally {
    saving.value = false;
  }
}

async function handleUpdate() {
  if (!editForm.value.id) {
    toast("No schedule selected", "error");
    return;
  }

  saving.value = true;
  try {
    await cronScheduleStore.update(editForm.value.id, {
      name: editForm.value.name,
      interval: editForm.value.interval,
      // is_enabled is toggled separately by the switch on the list
    });
    closeModal("edit_cronjobschedule");
  } catch (e) {
    // error toast already handled in the store
  } finally {
    saving.value = false;
  }
}

// 🔴 New: handle delete confirmation – emit to parent then close modal
function handleConfirmDelete() {
  emit("confirm-delete");
  closeModal("delete_modal");
}

function forceModalCleanup() {
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("padding-right");

  const backdrops = document.querySelectorAll(".modal-backdrop");
  backdrops.forEach((b) => b.remove());
}
</script>
